import {BASE_URL} from '../../../api'
import config from '../../config'
const {axios} = config

// Admin writing helper (roadmap #17.4). kind: 'push' | 'faq' | 'meditation'
export const aiDraft = async (kind, idea, extra = {}) => {
  const {data} = await axios.post(`${BASE_URL}/admin/ai/draft`, {kind, idea, ...extra})
  return data.data
}
export const aiError = (e) => e?.response?.data?.message || 'AI could not write that - please try again.'
